<template>
    <div class="mapping-modal">
        <v-dialog
            v-model="showModal"
            transition="dialog-top-transition"
            width="940px"
            min-height="537px"
            max-height="771px"
            @click:outside="reset()"
            scrollable
        >
            <v-card>
                <v-card-title width="100%"> Pilih Topik </v-card-title>
                <v-divider></v-divider>

                <v-card-text class="pa-0 ma-0" style="min-height: 13%">
                    <v-container fluid>
                        <v-row no-gutters>
                            <v-col cols="*">
                                <v-text-field
                                    v-model="query"
                                    outlined
                                    height="36px"
                                    hide-details
                                    small
                                    dense
                                    class="search_box"
                                    placeholder="Ketik kata kunci dan tekan enter"
                                >
                                    <template slot="prepend-inner">
                                        <svg
                                            style="margin-top: 10px !important"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M8.33342 15.0001C9.81256 14.9998 11.2491 14.5046 12.4142 13.5934L16.0776 17.2567L17.2559 16.0784L13.5926 12.4151C14.5042 11.2498 14.9997 9.81295 15.0001 8.33341C15.0001 4.65758 12.0092 1.66675 8.33342 1.66675C4.65758 1.66675 1.66675 4.65758 1.66675 8.33341C1.66675 12.0092 4.65758 15.0001 8.33342 15.0001ZM8.33342 3.33341C11.0909 3.33341 13.3334 5.57591 13.3334 8.33341C13.3334 11.0909 11.0909 13.3334 8.33342 13.3334C5.57591 13.3334 3.33341 11.0909 3.33341 8.33341C3.33341 5.57591 5.57591 3.33341 8.33342 3.33341Z"
                                                fill="#073554"
                                            />
                                            <path
                                                d="M9.50994 7.15507C9.82577 7.47174 9.99994 7.89007 9.99994 8.33341H11.6666C11.6673 7.89543 11.5813 7.46165 11.4133 7.05714C11.2454 6.65264 10.999 6.28543 10.6883 5.97674C9.4266 4.71674 7.2391 4.71674 5.97827 5.97674L7.15494 7.15674C7.78827 6.52507 8.87994 6.52674 9.50994 7.15507Z"
                                                fill="#073554"
                                            />
                                        </svg>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-text class="pa-4">
                    <v-list
                        v-if="!this.mapelId"
                        three-line
                        style="min-height: none !important"
                    >
                        <template>
                            <v-list-item
                                v-for="(card, index) in filteredCards"
                                v-bind:key="index"
                                @click="onCardSelected(card)"
                            >
                                <v-list-item-avatar>
                                    <v-img
                                        :src="
                                            card.picture
                                                ? card.picture
                                                : '@/assets/blank.svg'
                                        "
                                        :style="
                                            $vuetify.breakpoint.smAndDown
                                                ? 'background-size:20px'
                                                : ''
                                        "
                                    ></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content
                                    v-if="$vuetify.breakpoint.mdAndUp"
                                    class="pt-4 pb-6"
                                >
                                    <v-list-item-title>
                                        <span
                                            class="roboto-text darkblue--text"
                                            :class="
                                                $vuetify.breakpoint.smAndDown
                                                    ? 'font-weight-600'
                                                    : 'font-weight-700'
                                            "
                                            :style="
                                                $vuetify.breakpoint.smAndDown
                                                    ? 'font-size:15px'
                                                    : ''
                                            "
                                        >
                                            {{ card.name }}
                                        </span>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        Kode: {{ card.code }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action
                                    class="d-flex align-self-center"
                                >
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-list>
                    <v-row v-else>
                        <v-col
                            cols="4"
                            class="pa-3"
                            v-for="(card, index) in filteredCards"
                            v-bind:key="index"
                        >
                            <v-card flat outlined @click="onCardSelected(card)">
                                <v-card-title>
                                    <v-list class="pa-0 ma-0" width="100%">
                                        <v-list-item class="pa-0 ma-0">
                                            <v-list-item-content
                                                class="pa-0 ma-0"
                                            >
                                                <v-list-item-title
                                                    class="text-subtitle-1 font-weight-bold black--text"
                                                    style="
                                                        word-break: break-word !important;
                                                    "
                                                >
                                                    {{ card.name }}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-card-title>
                                <v-card-subtitle
                                    >Kode: {{ card.code }}</v-card-subtitle
                                >
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn text @click="reset()">Close</v-btn>
                    <v-btn dark color="blew" @click="submitData()"
                        >Simpan</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import ItembankService from "@/modules/itembank/services/itembank.js";
import Modal from "@/modules/global/components/plugins/Modal";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "mapping-modal",

    components: {
        "app-modal": Modal,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            mapels: [],
            cards: [],
            filteredCards: [],
            topics: null,
            isLoading: false,
            mapelId: null,
            babId: null,
            subBabId: null,
            selectedCard: null,
            query: "",
            showModal: true,
        };
    },

    mounted: function () {
        var mapels = JSON.parse(localStorage.mapels);
        this.mapels = mapels;

        var context = this;
        this.mapels.forEach(function (mapel) {
            var card = {
                id: mapel.id,
                type: "mapel",
                picture:
                    mapel.picture != null
                        ? mapel.picture
                        : "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png",
                code: mapel.code,
                name: mapel.nama,
            };

            context.cards.push(card);
        });

        this.filteredCards = this.cards;
    },

    watch: {
        query: function (val) {
            var filtered = this.cards.filter(function (card) {
                return card.name.toLowerCase().includes(val.toLowerCase());
            });

            this.filteredCards = filtered;
        },

        cards: function (val) {
            this.filteredCards = val;
            this.query = "";
        },
    },

    methods: {
        onCardSelected: function (card) {
            var context = this;
            this.selectedCard = card;

            if (!this.topics) {
                this.cards = [];
                this.mapelId = card.id;
                this.isLoading = true;
                ItembankService.getListOfTopic(card.code, function (response) {
                    if (response.success) {
                        context.topics = response.data;
                        context.topics.forEach(function (topic) {
                            var card = {
                                id: topic.id,
                                type: "bab",
                                picture:
                                    "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png",
                                code: topic.code,
                                name: topic.nama,
                            };
                            context.cards.push(card);
                        });
                    }
                    context.isLoading = false;
                });
            } else {
                this.isLoading = true;
                if (card.type === "bab") this.babId = card.id;
                else if (card.type === "sub_bab") this.subBabId = card.id;
                else if (card.type === "sub_sub_bab")
                    this.subSubBabId = card.id;

                var context = this;
                var data = [];

                if (this.babId) {
                    data = this.topics.find(function (topic) {
                        return topic.id === context.babId;
                    });
                }

                if (this.subBabId) {
                    var tmp = data.subs.find(function (d) {
                        return d.id === context.subBabId;
                    });

                    data = tmp;
                }

                if (this.subSubBabId) {
                    this.cards = [];
                    this.isLoading = false;
                    return;
                }

                this.cards = [];
                var cardType = "bab";
                if (this.babId) cardType = "sub_bab";
                if (this.subBabId) cardType = "sub_sub_bab";

                data.subs.forEach(function (d) {
                    var card = {
                        id: d.id,
                        type: cardType,
                        picture:
                            "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png",
                        code: d.code,
                        name: d.nama,
                    };
                    context.cards.push(card);
                });

                this.isLoading = false;
            }
        },

        submitData: function () {
            this.isLoading = true;
            var gradeId = this.$route.query.grade_id;
            var interest = this.$route.query.interest;

            var context = this;
            ItembankService.createTopicMapping(
                this.mapelId,
                this.babId,
                this.subBabId,
                this.subSubBabId,
                gradeId,
                interest,
                function (response) {
                    context.isLoading = false;
                    if (response.success) {
                        context.$emit("finish");
                    }
                },
            );
        },

        reset: function () {
            this.topics = null;
            this.mapelId = null;
            this.babId = null;
            this.subBabId = null;
            this.$emit("cancel");
        },
    },
};
</script>



// WEBPACK FOOTER //
// MappingModal.vue?fd85451e